import React from 'react';
import { MdSearch as IconSearch } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { bindActionCreators } from 'redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

import { TasksTable } from '../../custom/table';
import { SubViewHeader } from '../../lib/components/subHeader';
import { SizeMe } from 'react-sizeme';
import Result from 'iotera-base/result';
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import IoteraClass from '../../lib/components/react/react-class';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const INIT_TASKS = 'INIT_TASKS';
const CONTROL_ACTIVATE = "CONTROL_ACTIVATE";
const DELETE = "DELETE"
const WKEY = 'TASK_LIST';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class TaskList extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      taskList: this.props.data,
      filters: {
        assigner: [],
        dueDate: [],
        tags: [],
        status: []
      },
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }
    this.resize = this.resize.bind(this);
  }

  resize(event) {
    this.setState({
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    })
  }

  handleChange = event => {
    this.setState({ search: event.target.value })
  }

  handleKeyDown = event => {
    this.handleSearchFilter()
  }

  handleSearchFilter = () => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { taskList } = _state
    let newState = Object.assign({}, _state);
    let tasks = []
    taskList.forEach((task) => {
      let foundDevice = (_state.search === '') ||
        ((task.title.search(_state.search)) !== -1)
      if (foundDevice) {
        tasks.push(task)
      }
    })
    newState.taskList = tasks
    _this.setState({ taskList: tasks });
    if (_state.search.length === 0) {
      _this.setState({ taskList: _props.data });
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { taskList, search } = _state
    window.onresize = _this.resize;
    let data = safeDeepGet(_props, ['data'], []);
    if (_state.filter) {
      data = taskList
    }
    const length = data.length;
    const finalData = safeDeepGet(_props, ['finalData']);
    if (finalData) {
      return (
        <div>
          <Form>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <InputGroup>
                  <Input placeholder="Cari berdasarkan nama tugas" value={search}
                    onChange={_this.handleChange} onKeyDown={_this.handleKeyDown} type="text" step="1" />
                  <InputGroupAddon addonType="append"><Button onClick={_this.handleSearchFilter}>
                    <IconSearch size={16} /></Button>
                  </InputGroupAddon>
                </InputGroup>
              </div>
            </FormGroup>
            {length > 0 ?
              <SizeMe>{({ size }) =>
                < div className="table-responsive">
                  <TaksListTableWR data={data} tableSize={size} handleDelete={_props.handleDelete}
                    andleChangeStatus={_props.handleChangeStatus} />
                </div>
              }</SizeMe>
              :
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... tugas tidak ditemukan</div>
              </div>
            }
          </Form>
        </div>
      )
    } else {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... Tugas Masih Kosong</div>
                <div style={{ textAlign: 'center' }}>Daftar tugas yang telah dibuat akan ditampilkan disini.</div>
              </div>
            </FormGroup>
          </Form>
        </div>
      )
    }
  }
}

const TaksListTableWR = withRouter(TasksTable);

class Tasks extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }

  handleDelete(deviceId) {
    this.props.wSingleRequestCall({
      id: DELETE,
      body: {
        id: deviceId
      }
    })
  };

  handleChangeStatus = (id, value) => {
    const _this = this
    const _props = _this.props
    _this.setState({ loading: true })
    _props.wSingleRequestCall({
      id: CONTROL_ACTIVATE,
      body: {
        id,
        active: value
      }
    });
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/task/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false
            })
          }
        }
      }
    );

    _props.wSetConfig({
      single_config: {
        [CONTROL_ACTIVATE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/task/notification/activate"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_task_list_')
                  _props.showSingleNotification({ message: 'Ubah notifikasi tugas berhasil', level: 'success' });
                  return;
                } else {
                  _this.setState({ loading: false })
                  _props.showSingleNotification({ message: 'Ubah notifikasi tugas gagal', level: 'success' });

                }
              } else {
                _this.setState({ loading: false })
                _props.showSingleNotification({ message: 'Ubah notifikasi tugas gagal', level: 'success' });
              }
            }
          }
        },
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/task/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_task_list_')
                  _props.showSingleNotification({ message: 'Hapus task berhasil', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Hapus task gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const _this = this
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let task = safeDeepGet(_props, ['items'], {});
    let data = safeDeepGet(task, ['data'], [])
    let { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let finalData = false;
    if (data.length > 0) {
      finalData = true;
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tugas' subTitle='Seluruh tugas yang terdaftar di aplikasi ini.' />
          <div className="view-content-dashboard">
            <TaskList {..._props} data={task.data} finalData={finalData}
              handleDelete={_this.handleDelete} handleChangeStatus={_this.handleChangeStatus} />
          </div>
        </div>
      </Loader >
    )
  }
}

const mapStateToProps = (state) => ({
  items:
  {
    data: wSelector.getSoleInitMappedRPayload(state, 'tasks')
  }
})

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Tasks));